/**
 * Deckplans mobile carousel — prev/next navigation
 */
(function () {
  document.querySelectorAll('.deckplans-carousel').forEach(function (carousel) {
    var panes = carousel.querySelectorAll('.deckplans-carousel__pane');
    var label = carousel.querySelector('.deckplans-carousel__label');
    var prevBtn = carousel.querySelector('.deckplans-carousel__arrow.-prev');
    var nextBtn = carousel.querySelector('.deckplans-carousel__arrow.-next');
    var total = panes.length;
    var current = 0;

    if (!total || !label || !prevBtn || !nextBtn) return;

    function show(index) {
      panes.forEach(function (p) { p.classList.remove('active'); });
      panes[index].classList.add('active');
      label.textContent = panes[index].dataset.name || '';
      current = index;
    }

    prevBtn.addEventListener('click', function () {
      show(current > 0 ? current - 1 : total - 1);
    });

    nextBtn.addEventListener('click', function () {
      show(current < total - 1 ? current + 1 : 0);
    });
  });
})();

/**
 * Deckplans — auto-switch to carousel when desktop tabs overflow or wrap
 *
 * Temporarily forces white-space:nowrap on tabs to measure whether their
 * content would overflow the header. This catches both "too many tabs" and
 * "long tab names wrapping to 2+ lines" scenarios.
 */
(function () {
  var blocks = document.querySelectorAll('.pontoon-cruise-deckplans');
  if (!blocks.length) return;

  function check() {
    var isDesktop = window.matchMedia('(min-width: 992px)').matches;

    blocks.forEach(function (block) {
      if (!isDesktop) {
        block.classList.remove('force-carousel');
        return;
      }

      var header = block.querySelector('.desktop-layout .tab-header');
      var tabs = header ? header.querySelectorAll('.tab-link') : [];
      if (!tabs.length) return;

      // Temporarily prevent wrapping to test if content would overflow
      tabs.forEach(function (t) { t.style.whiteSpace = 'nowrap'; });
      var wouldOverflow = header.scrollWidth > header.clientWidth;
      tabs.forEach(function (t) { t.style.whiteSpace = ''; });

      if (wouldOverflow) {
        block.classList.add('force-carousel');
      } else {
        block.classList.remove('force-carousel');
      }
    });
  }

  check();
  window.addEventListener('resize', check);
})();
